import React from 'react'
import '../components/styles/Banner2.css'


export function Banner2() {
    return (
        <div className='banner2'>
            <div>
                <h1>
                    Book a bike by getting in touch with us
                </h1>
            </div>
        </div>
    )
}

